import { BaseEntity } from "@app/models/rest/base-entity";
import { WebhookDefinition } from "@app/models/rest/webhook-definition";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("webhookStagings")
export class WebhookStaging extends BaseEntity {
  creationDate: Date;
  endpoint: string;
  lastError: string;
  lastHttpStatus: number;
  requestBody: string;
  requestParams: string;
  retries: number;
  status: string;
  webhook: WebhookDefinition;
}
